/**
 * @flow
 * @relayHash b5b1c52118bef09ff12acde79d79b6e1
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type CSVImportEntity = "CUSTOMER" | "ITEM" | "ORDER" | "VENDOR";
export type CSVImportStatus = "COMPLETED" | "FAILED" | "IMPORTING" | "MAPPING" | "UPLOADING" | "VALIDATING";
export type CSVImportSceneHistoryQueryVariables = {||};
export type CSVImportSceneHistoryQueryResponse = {|
  +csvImports: $ReadOnlyArray<{|
    +csvImportId: string,
    +entityType: CSVImportEntity,
    +fileName: string,
    +status: CSVImportStatus,
    +importedCount: ?number,
    +updatedCount: ?number,
    +skippedCount: ?number,
    +totalRows: ?number,
    +createdAt: ?string,
  |}>
|};
export type CSVImportSceneHistoryQuery = {|
  variables: CSVImportSceneHistoryQueryVariables,
  response: CSVImportSceneHistoryQueryResponse,
|};
*/


/*
query CSVImportSceneHistoryQuery {
  csvImports {
    csvImportId
    entityType
    fileName
    status
    importedCount
    updatedCount
    skippedCount
    totalRows
    createdAt
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "csvImports",
    "storageKey": null,
    "args": null,
    "concreteType": "CSVImport",
    "plural": true,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "csvImportId",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "entityType",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "fileName",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "status",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "importedCount",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "updatedCount",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "skippedCount",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "totalRows",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "createdAt",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "CSVImportSceneHistoryQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": (v0/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "CSVImportSceneHistoryQuery",
    "argumentDefinitions": [],
    "selections": (v0/*: any*/)
  },
  "params": {
    "operationKind": "query",
    "name": "CSVImportSceneHistoryQuery",
    "id": null,
    "text": "query CSVImportSceneHistoryQuery {\n  csvImports {\n    csvImportId\n    entityType\n    fileName\n    status\n    importedCount\n    updatedCount\n    skippedCount\n    totalRows\n    createdAt\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '1fbd9735054896dfd20c1c99a2cc7954';
module.exports = node;
